// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "bj_bX";
export var MuiTooltipPopper = "bj_bY";
export var button = "bj_b1";
export var icon = "bj_n";
export var iconWrapper = "bj_b0";
export var title = "bj_bp";
export var wrapper = "bj_bZ";